import { render, staticRenderFns } from "./UpboxDetails.vue?vue&type=template&id=279a374e"
import script from "./UpboxDetails.vue?vue&type=script&lang=js"
export * from "./UpboxDetails.vue?vue&type=script&lang=js"
import style0 from "./UpboxDetails.vue?vue&type=style&index=0&id=279a374e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports